import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import * as themeUtilities from '@/utilities/client-components/utilities/themeUtils'

import withSpacing from './WithSpacing'

const StyledFallbackElement = styled.div`
  background: ${(props: any) => themeUtilities.getRgbaColor(props.theme, 'light')};
  color: ${(props: any) => themeUtilities.getRgbaColor(props.theme, 'dark')};
  padding: 7px;
  text-align: center;

  p {
    margin: 0;
  }
`

const FallbackElement = () => {
  const { t } = useTranslation('client')

  return (
    <StyledFallbackElement data-id="wg-fallback">
      <p>{t('client:Unsupported Element')}</p>
    </StyledFallbackElement>
  )
}

FallbackElement.displayName = 'FallbackElement'

export default withSpacing(FallbackElement)
